class MegaMenu {
    constructor() {
        this.nav = document.querySelector('.header__nav');
        this.navItems = document.querySelectorAll('.header__nav__item--expandable');
        this.toggleBtn = document.querySelector('#header__menu-toggle__input');
        this.activeMenu = null;
        this.htmlEl = document.getElementsByTagName( 'html' )[0];

        if (this.navItems == null || this.nav == null) {
            return;
        }

        this.addEventListeners();
        window.dispatchEvent(new Event('resize'));
    }

    addEventListeners() {
        window.addEventListener('resize', (e) => {
            if(window.innerWidth < 1272) this.nav.style['height'] = `${window.innerHeight - 30}px`;
            else this.nav.style['height'] = 'auto';
        });

        window.addEventListener('click', (e) => {
            if (this.activeMenu && !document.getElementById(this.activeMenu).contains(e.target) && !e.target.classList.contains('header__nav__item--title')){
                this.hideAll();
            }
        });

        this.navItems.forEach((el) => {
            el.addEventListener("click", (e) => {
                (e.target.parentNode.getAttribute('aria-expanded') === 'true') ? this.hideMenu(e) : this.showMenu(e);
            });
        })

        if (this.toggleBtn != null) {
            this.toggleBtn.addEventListener('change', (e) => {
                if (e.target.checked) {
                    document.body.classList.add('body--noscroll');
                    this.htmlEl.classList.add('body--noscroll');
                } else {
                    document.body.classList.remove('body--noscroll');
                    this.htmlEl.classList.remove('body--noscroll');
                }
            });
        }
        const mainButtonSelectors = [
            ".header__nav__item--title", 
            ".button__mypages", 
            ".branch__open",
            ".header__toolbar__item--desktop"
        ]
        
        const subMenuSelectors = [
            '.megamenu__list .megamenu__link', +
            '.button__mypages + .dropdown__container .dropdown__item',
            '.megamenu__title-link .megamenu__link'
        ]
        
        const mainButtons = document.querySelectorAll(mainButtonSelectors.join(', '));
        const subMenuLinks = document.querySelectorAll(subMenuSelectors.join(', '));
        const quickLinks = document.querySelectorAll('.megamenu__button');
        
        mainButtons.forEach(button => {
            button.addEventListener('click', (e) => {
                this.pushInteraction(e.target.innerText, "Main menu")
            });
        });   
        
        subMenuLinks.forEach(link => {
            link.addEventListener('click', (e) => {
                this.pushInteraction(e.target.innerText, "Submenu")
            });
        });
        
        quickLinks.forEach(link => {
            link.addEventListener('click', (e) => {
                this.pushInteraction(e.target.innerText, "Quick links")
            });
        });
    }

    
    pushInteraction(text, type) {
        if(!text || !type) return;
        const dataLayer = window.dataLayer || [];
        
        const data = {
            event: 'menuClick',
            menuLevel: type,
            clickText: text.trim()
        }
        
        dataLayer.push(data);
    }


    showMenu(e) {
        this.hideAll();
        const megamenuElement = e.target.parentNode.querySelector('.megamenu');
        e.target.parentNode.setAttribute('aria-expanded', 'true');
        if (megamenuElement) {
            if ((e.target.getBoundingClientRect().left + megamenuElement.offsetWidth) > window.innerWidth )
                e.target.parentNode.querySelector('.megamenu').classList.add('megamenu--positionleft')
                this.activeMenu = e.target.parentNode.querySelector('.megamenu').id;
        }

        e.target.parentNode.setAttribute('aria-expanded', 'true');
    }

    hideMenu(e) {
        this.activeMenu = null;
        e.target.parentNode.setAttribute('aria-expanded', 'false');
        e.target.blur();
    }

    hideAll(){
        this.activeMenu = null;
        [].forEach.call(this.navItems, el => {
            el.blur();
            el.setAttribute('aria-expanded','false');
        })
    }
}

document.addEventListener("DOMContentLoaded", () => new MegaMenu());


